import React from "react";
import useMentorsipCurriculum from "./use-mentorship-curriculum";
import MentorshipPlanTemplateDetails from "./mentorship-plan-template/mentorship-plan-template-details";
import { useAppSelector } from "state/hooks";
import MentorshipCurriculumVariantB from "../mentorship-curriculum-variant-b/mentorship-curriculum-varaint-b";

type Props = {};

const MentorshipCurriculum = (props: Props) => {
  const ROLE = useAppSelector((state) => state.generalConfigs.join_role);
  const { templateForMonths, handleTemplateForMonths, templateDataToShow } =
    useMentorsipCurriculum();

  return (
    <div className="p-3 md:p-6 bg-[#F6F9FC] rounded-xl ">
      <div className="flex flex-col md:flex-row gap-y-4 justify-between items-start md:items-center">
        <div className="space-y-1">
          <p className="text-[#2E2E2E] text-lg md:text-[22px] font-semibold leading-6">
            Curriculum I will Cover in 1:1 sessions.
          </p>
          <p className="hidden md:block text-[#525866] text-xs leading-[17px]">
            Breakdown of all the topics that I will guide you through as part of
            the mentorship.
          </p>
          <p className="text-[#525866] text-[11px] leading-[17px] md:hidden">
            Breakdown of all the topics that I will guide you through.
          </p>
        </div>
        <div className="h-9 flex">
          {[
            { duration: 6, name: "6 Months" },
            { duration: 3, name: "3 Months" },
            { duration: 1, name: "1 Month" },
          ].map((item, index) => {
            return (
              <div
                className={`flex justify-center items-center px-3 text-[#0E121B] text-xs font-semibold border border-[#F2F2F2] cursor-pointer 
              ${
                templateForMonths === item?.duration
                  ? "border-b-2 border-b-[#335CFF]"
                  : ""
              }`}
                key={item?.duration}
                onClick={() => {
                  handleTemplateForMonths(item?.duration);
                }}
              >
                {item?.name}
              </div>
            );
          })}
        </div>
      </div>
      <div className="my-7 h-[1px] w-full bg-[#E9E9E9]" />
      <MentorshipCurriculumVariantB
        mentorshipPlanDataCurriculam={templateDataToShow}
      />
    </div>
  );
};

export default MentorshipCurriculum;

// <div className="bg-[#111] border border-[#222] rounded-2xl p-5 space-y-6">
//   <div className="flex justify-between items-center">
//     <div className="space-y-2 max-w-[320px]">
//       <p className="text-[23px] font-medium text-white">
//         Mentorship Curriculum
//       </p>
//       <p className="text-gray-400 text-xs leading-[18px] tracking-[-0.18px]">
//         Clear breakdown of all the topics the mentor will guide you through
//         as part of the long-term mentorship.
//       </p>
//     </div>
//     <div className="flex border border-[#333] rounded-xl overflow-hidden">
//       {[
//         { duration: 6, name: "6 Months" },
//         { duration: 3, name: "3 Months" },
//         { duration: 1, name: "1 Month" },
//       ].map((item, index) => {
//         return (
//           <div
//             className={`p-2 flex justify-center items-center
// 							  ${templateForMonths === item?.duration ? "border-b border-b-white" : ""}
//                 ${index === 1 ? "border-x border-[#333]" : ""}
// 						`}
//             key={item?.duration}
// onClick={() => {
//   handleTemplateForMonths(item?.duration);
// }}
//           >
//             <p
//               className={`cursor-pointer  text-[10px] leading-4 ${
//                 templateForMonths === item?.duration
//                   ? "text-white font-bold"
//                   : "text-gray-400 font-medium "
//               }`}
//             >
//               {item?.name}
//             </p>
//           </div>
//         );
//       })}
//     </div>
//   </div>

//   <div className="py-3 border-y border-[#222]">
//     <div className="py-1.5 px-2 bg-[rgba(255,183,11,0.15)] flex justify-center rounded-md">
//       <p className="text-[11px] text-[#F6B51E] leading-3">
//         {ROLE === "mentor"
//           ? " Discuss the mentee's pain points and outline what all you will cover through this mentorship curriculum"
//           : "This is a tentative curriculum. Ask the mentor to customize it during the trial session to fit your needs."}
//       </p>
//     </div>
//   </div>

//   {/* <MentorshipPlanTemplateDetails
//     mentorshipPlanData={templateDataToShow}
//     templateForMonths={templateForMonths}
//   /> */}

//   <MentorshipCurriculumVariantB
//     mentorshipPlanDataCurriculam={templateDataToShow}
//   />
// </div>
